module.exports = "<cpropre-signin \n    (login) = \"userLogin($event)\"\n    [errorMessage] = \"getError()\">\n</cpropre-signin>\n"